import React from 'react';
import { FadeIn } from './FadeIn';
export function Mission() {
  const transformations = [{
    from: 'epuizare și confuzie',
    to: 'claritate și direcție'
  }, {
    from: 'lipsa de validare',
    to: 'încredere autentică în sine'
  }, {
    from: 'tipare repetitive',
    to: 'o viață care te reprezintă'
  }];
  return <section className="py-20 md:py-28 bg-ivory overflow-hidden relative" data-id="element-594">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gold/5 rounded-l-full blur-3xl pointer-events-none" data-id="element-595"></div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-596">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-597">
          {/* Left Side - Tall portrait photo */}
          <div className="lg:col-span-5" data-id="element-598">
            <FadeIn direction="left" data-id="element-599">
              <div className="relative max-w-[420px] mx-auto lg:mx-0" data-id="element-600">
                <div className="rounded-[24px] overflow-hidden shadow-2xl aspect-[3/4]" data-id="element-601">
                  <img src="https://cdn.magicpatterns.com/uploads/bbhRnscRmaZkzuZMMer6an/Foto_1.jpg" alt="Mihaela Iovu" className="w-full h-full object-cover object-center" data-id="element-602" />
                </div>
                {/* Decorative border offset */}
                <div className="absolute -bottom-4 -right-4 w-full h-full rounded-[24px] border-2 border-gold/30 -z-10" data-id="element-603"></div>
              </div>
            </FadeIn>
          </div>

          {/* Right Side - Text + plain transformations */}
          <div className="lg:col-span-7" data-id="element-604">
            <FadeIn data-id="element-605">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium mb-8 text-center lg:text-left text-forest" data-id="element-606">
                Ghidare către încredere și aliniere interioară
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-607">
              <div className="space-y-5 text-charcoal/80 font-sans text-[19px] leading-relaxed" data-id="element-608">
                <p data-id="element-609">
                  Ghidez femei de carieră 30+ care se simt epuizate, fără
                  direcție și deconectate de ele însele să își redobândească
                  încrederea, speranța și sensul în viață.
                </p>
                <p data-id="element-610">
                  Prin metoda A.R.I.S.E., lucrăm simultan pe minte, emoții și
                  sistemul familial, pentru ca schimbarea să fie reală, nu doar
                  înțeleasă.
                </p>
                <p data-id="element-611">
                  Integrez NLP, constelații familiale, hipnoză și coaching
                  profund într-un proces structurat, aplicat pe viața reală,
                  care te duce de la{' '}
                  <span className="font-serif italic text-forest text-xl" data-id="element-612">
                    „funcționez"
                  </span>{' '}
                  la{' '}
                  <span className="font-serif italic text-forest text-xl" data-id="element-613">
                    „trăiesc"
                  </span>
                  .
                </p>
              </div>
            </FadeIn>

            {/* Plain text transformations - continues below paragraph */}
            <FadeIn delay={0.2} data-id="element-614">
              <div className="mt-10 pt-8 border-t border-gold/30" data-id="element-615">
                <h3 className="font-display text-xs font-semibold tracking-[0.3em] text-gold-dark uppercase mb-6" data-id="element-616">
                  Transformarea ta
                </h3>

                <div className="space-y-5" data-id="element-617">
                  {transformations.map((item, index) => <div key={index} className="text-[18px] leading-relaxed" data-id="element-618">
                      <span className="text-charcoal/50" data-id="element-619">De la </span>
                      <span className="text-charcoal/80" data-id="element-620">{item.from}</span>
                      <span className="text-charcoal/50" data-id="element-621"> la </span>
                      <span className="font-serif italic text-forest font-medium text-[20px]" data-id="element-622">
                        {item.to}
                      </span>
                    </div>)}
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}